import { render, staticRenderFns } from "./payment-page-table.vue?vue&type=template&id=1d116df6&scoped=true&"
import script from "./payment-page-table.vue?vue&type=script&lang=js&"
export * from "./payment-page-table.vue?vue&type=script&lang=js&"
import style0 from "./payment-page-table.vue?vue&type=style&index=0&id=1d116df6&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d116df6",
  null
  
)

export default component.exports